import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "e2e93fa9-bdfa-485e-84dd-95f9494dea7d",
  publicId: "22",
  name: "Introduction to listening experiments",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },

  body: [principle01, task01, task02],
};

export default lesson;
